export default __webpack_public_path__ + "62953d4ab9b7dc02e4f4c7db92e4a2ac.ttf";